type TranslationSection = {
  [category: string]: string[];
};

export const translationsForRehabState = (apiName: string): TranslationSection | object => {
  if (!apiName) {
    throw new Error('RehabState apiName is required to fetch translations');
  }

  switch (apiName) {
    case 'queue':
      return {
        General: ['Queue'],
        'Notification Settings': ['Patient Added To Queue'],
      };
    case 'inTreatment':
      return {
        General: ['Admitted & In Treatment', 'Admission', 'Readmission'],
        'Patient Story Settings': ['Admit In Olio', 'Pending Admission'],
        'Notification Settings': [
          'Patient Moved to Admitted And In Treatment',
          'Admission Date',
          'The initial authorization is only valid for 1 more day pending patient admission.',
        ],
      };
    case 'discharged':
      return {
        General: ['Discharged', 'Discharge'],
        'Insights Settings': ['Total Discharges'],
        'Notification Settings': ['Patient Discharged', 'Nearing Projected Discharge'],
      };
    default:
      return {};
  }
};

type Translation = {
  [key: string]: {
    [key: string]: string;
  };
};

export const flattenTranslations = (translations: Translation) => {
  return Object.assign({}, ...Object.values(translations));
};

export const unflattenTranslations = (flatTranslations: Record<string, string>) => {
  if (!flatTranslations) return {};

  const nested: Record<string, Record<string, string>> = {};

  ['queue', 'inTreatment', 'discharged'].forEach((apiName) => {
    const validKeys = Object.values(translationsForRehabState(apiName)).flat();

    nested[apiName] = {};

    Object.entries(flatTranslations).forEach(([flatKey, value]) => {
      const matchingKey = validKeys.find((validKey) => validKey.toLowerCase() === flatKey.toLowerCase());

      if (matchingKey) {
        nested[apiName][matchingKey] = value;
      }
    });
  });

  return nested;
};
